<template>
  <div class="cxm-MultipleChoice">
    <div :class="questionData.horizontal_align ? 'flex ' : 'inline-block'">
      <div
        v-for="(option, index) in options"
        :key="index"
      >
        <div
          class="cxm-MultipleChoice-Option"
          @click="handleAnswerChange(option.option)"
        >
          <Checkbox
            v-if="questionData.multiple_answers"
            class="cxm-MultipleChoice-Checkbox"
            :no-spacing="true"
            :value="option.option"
            :model-value="isSelected(option.option)"
            @click.native.stop.prevent="handleAnswerChange(option.option)"
          />
          <Radio
            v-else
            :value="option.option"
            :model-value="radio"
            @change.native.stop.prevent="handleAnswerChange(option.option)"
            @click.native.stop
          />
          <span class="cxm-MultipleChoice-Choice">
            {{ option.letter }}
          </span>
          <span class="cxm-MultipleChoice-Text">{{ option.option[language] }}</span>
        </div>
      </div>
    </div>

    <div v-if="questionData.option_other">
      <Input
        type="text"
        class="other-input"
        :label="otherLabel"
        :placeholder="commentPlaceholder"
        :value="other"
        maxlength="500"
        @blur="$emit('blur', $event)"
        @input="handleOtherChange"
      />
    </div>
  </div>
</template>

<script>
import Radio from '@/packages/ui/components/Radio/Radio.vue';
import Checkbox from '@/packages/ui/components/Checkbox/Checkbox.vue';
import Input from '../../Input/Input.vue';

const letters = {
  0: 'A',
  1: 'B',
  2: 'C',
  3: 'D',
  4: 'E',
  5: 'F',
  6: 'G',
  7: 'H',
  8: 'I',
  9: 'J',
  10: 'K',
  11: 'L',
  12: 'M',
  13: 'N',
  14: 'O',
  15: 'P',
  16: 'Q',
  17: 'R',
  18: 'S',
  19: 'T',
  20: 'U',
  21: 'V',
  22: 'X',
  23: 'Z',
};

export default {
  components: { Input, Radio, Checkbox },
  props: {
    questionData: {
      type: Object,
      default: () => {},
    },
    answer: {
      type: Array,
      default: () => [],
    },
    other: {
      type: String,
      default: '',
    },
    otherLabel: {
      type: String,
      default: '',
    },
    handleOtherChange: {
      type: Function,
      default: () => {},
    },
    commentPlaceholder: {
      type: String,
      default: '',
    },
    language: {
      type: String,
      default: 'pt_BR',
    },
  },
  data() {
    return {
      radio: '',
    };
  },
  computed: {
    options() {
      let opt = [...this.questionData.options];
      if (this.questionData.randomize) {
        opt = opt.sort(() => Math.random() - 0.5);
      }
      opt = opt.map((o, index) => ({ letter: letters[index], option: o }));
      return opt;
    },
  },
  watch: {
    other(value) {
      if (value) {
        this.radio = '';
      }
    },
  },
  methods: {
    handleAnswerChange(value) {
      this.radio = value;
      this.$emit('change', value);
    },
    isSelected(option) {
      if (!this.answer) {
        return false;
      }
      return this.answer.find(
        (a) => a[this.language] === option[this.language],
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-MultipleChoice {
  width: 100%;
}
.cxm-MultipleChoice-Option {
  display: flex;
  align-items: center;
  border-radius: 100px;
  border: 1px solid var(--track-color-bluegray-60);
  margin-bottom: var(--track-spacing-md);
  padding: var(--track-spacing-xs) var(--track-spacing-md) var(--track-spacing-xs) var(--track-spacing-sm);
  cursor: pointer;

  @media (hover: hover) {
    &:hover:not(.option_selected) {
      background-color: rgba(238, 238, 238, 0.637);
    }
  }
}
.cxm-MultipleChoice-Choice {
  font-size: var(--track-font-size-xs);
  line-height: 140%;
  font-weight: var(--track-font-weight-semibold);
  color: var(--track-color-bluegray-60);
  margin-right: var(--track-spacing-sm);
}
.cxm-MultipleChoice-Text {
  font-size: var(--track-font-size-xs);
  line-height: 140%;
  font-weight: var(--track-font-weight-regular);
  color: var(--track-color-bluegray-60);
  word-break: break-word;
}
.cxm-MultipleChoice-Checkbox {
  margin-right: 5px;
}
</style>
